import type { SccrsGamingHall } from '@/entities/sccrs';
import { formatGamingHallRest } from '../lib';

export const GamingHallLabel = ({ hall }: { hall: SccrsGamingHall }) => {
  const rest = formatGamingHallRest(hall);

  if (hall.displayName) {
    return (
      <>
        <span className="font-bold">{hall.displayName}</span>
        {`, ${rest}`}
      </>
    );
  }

  return <>{rest}</>;
};
